<template>
    <div class="row py-4">
        <div class="col-2">
            <div style="width:100%;position: relative; float: left;">
                <div>

                    <ul class="my-filter-app float-end">
                        <li v-if="mesesNames">
                            <app-filter-select :defaults="mesesNames" label="Mês" :active="mesOption"
                                @handleSet="handleFilter" />
                        </li>
                        <li v-if="produto">
                            <app-filter-select :defaults="JSON.parse(produto.values)" label="Produto"
                                :active="produtoOption" @handleSet="handleFilter" />
                        </li>
                        <li v-if="time">
                            <app-filter-select :defaults="JSON.parse(time.values)" label="Time" :active="timeOption"
                                @handleSet="handleFilter" />
                        </li>
                        <li v-if="esteira">
                            <app-filter-select :defaults="JSON.parse(esteira.values)" label="Esteira"
                                :active="esteiraOption" @handleSet="handleFilter" />
                        </li>
                        <li v-if="statusNames">
                            <app-filter-select :defaults="statusNames" label="Status" :active="statusOption"
                                @handleSet="handleFilter" />
                        </li>
                    </ul>
                </div>

            </div>

        </div>
        <div class="col-10" v-if="!graficosCarregando">
            <!-- {{ graficosData }} -->
            <div class="row mx-0">
                <div class="col-6 mb-3 pr-0" v-if="graficosData.versionamento">
                    <app-apex-chart-pie label="Versionamento de peças" :chartData="graficosData.versionamento"
                        :key="JSON.stringify(graficosData.versionamento)" :colors="colorsTags" />
                </div>
                <div class="col-6 mb-3 pr-0" v-if="graficosData.versionamentoTemplatizado">
                    <app-apex-chart-pie label="Versionamento Templatizado"
                        :chartData="graficosData.versionamentoTemplatizado"
                        :key="JSON.stringify(graficosData.versionamentoTemplatizado)" :colors="colorsTags" />
                </div>
            </div>
            <div class="row mx-0" v-if="!graficosCarregando">
                <app-card-indicador label="Volume de peças" :values="graficosData.volumePecas"
                    v-if="graficosData.volumePecas" />
                <app-card-indicador label="Demandas únicas" :values="graficosData.demandasUnicas"
                    v-if="graficosData.demandasUnicas" />
                <app-card-indicador label="Peças templatizadas" :values="graficosData.templatizadas"
                    v-if="graficosData.templatizadas" />
            </div>
        </div>
    </div>
</template>

<script>
import AppApexChartBar from './DashComponents/AppexChartBar.vue'
import AppApexChartPie from './DashComponents/AppexChartPie.vue'
import AppFilterSelect from './SelecteFilter.vue';
import AppCardIndicador from './DashComponents/CardIndicadorl.vue'
import AppCardIndicadorPercentagem from './DashComponents/CardIndicadorPercentagem.vue'
import AppFormatosMeses from './DashComponents/AppexChartFormatosMeses.vue'
import AppFormatosProdutos from './DashComponents/AppexChartFormatosProdutos.vue'
import { mapActions } from "vuex";
import { formatos, colorsTags, status, mesesNames } from '../../../data/data-static.js'
export default {
    name: 'FiltroDashboard',
    components: {
        AppFilterSelect,
        AppApexChartPie,
        AppCardIndicador,
        //AppCardIndicadorPercentagem,
        //AppFormatosMeses,
        //AppApexChartBar,
        //AppFormatosProdutos
    },
    props: {
        userAdmin: { type: [Number, String], required: false },
        selected: {
            type: [Array, Object],
            required: true
        },
        buckets: {
            type: [Array, Object],
            required: true
        }
    },
    data() {
        return {
            produto: null,
            formatosNames: formatos,
            mesesNames: mesesNames,
            statusNames: status,
            time: null,
            esteira: null,
            produtoOption: [],
            timeOption: [],
            esteiraOption: [],
            statusOption: [],
            mesOption: ["07"],
            items: [],
            originalItems: [],
            ignoraMesItems: [],
            colorsTags: colorsTags,
            graficosData: {
                versionamento: null,
                versionamentoTemplatizado: null,
                volumePecas: null,
                demandasUnicas: null,
                templatizadas: null
            },
            graficosCarregando: true,
            versionamentoModelo: {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
            }

        };
    },
    async mounted() {
        const options = this.$getAPIHeaders(
            "GET",
            `task-all-properties-dash-board/${this.$route.params.id}`
        );

        try {
            const response = await this.axios(options);
            await this.forrmataData(response.data.data);
        } catch (error) {
            console.error('Erro no mounted:', error);
        }
    },
    watch: {
        selected: {
            handler(val) {
                if (Array.isArray(val) && val.length > 0) {
                    this.defaultTo(val);
                }
            },
            immediate: true
        },
        items: {
            handler(newItems) {
                this.setgraficosData();
            },
            immediate: false,
            deep: true
        }
    },
    methods: {
        ...mapActions([
            "showLoader",
        ]),
        defaultTo(selected) {
            const allProps = selected.flatMap(modelo => {
                return (modelo.properties || []).map(p => ({ ...p.propertie }));
            });

            allProps.forEach(e => {
                if (e.name === 'Produto') {
                    this.produto = e;
                } else if (e.name === 'Time') {
                    this.time = e;
                } else if (e.name === 'Esteira') {
                    this.esteira = e;
                }
            });
        },
        getFormatoName(id) {
            const found = formatos.find(f => f.id == id);
            return found ? found.value : '';
        },
        diminuiEFormata(v) {
            return String(parseInt(v, 10) - 1).padStart(2, '0');
        },
        handleFilter(label, idsSelecionados) {
            label = label !== 'Mês' ? label : 'Mes';
            const key = label.toLowerCase() + "Option";
            // Salva como array (ou array vazio se nullo)
            this[key] = idsSelecionados != null
                ? (Array.isArray(idsSelecionados) ? idsSelecionados : [idsSelecionados])
                : null;

            if (this[key].length === 0) {
                this[key] = null;
            }
            this.items = this.originalItems.filter(item => {
                const f = item.filters || {};
                // Função para comparação: sempre trata como array
                const compare = (campo, valoresSelecionados) => {
                    if (!valoresSelecionados || (Array.isArray(valoresSelecionados) && valoresSelecionados.length === 0)) return true;
                    let arrValores = [];
                    if (!Array.isArray(valoresSelecionados)) arrValores = [valoresSelecionados];
                    else arrValores = valoresSelecionados;

                    return arrValores.some(val => (f[campo] && f[campo].toString()) === val.toString());
                };

                return (
                    compare("Mes", this.mesOption)
                    && compare("Produto", this.produtoOption)
                    && compare("Time", this.timeOption)
                    && compare("Esteira", this.esteiraOption)
                    && compare("Status", this.statusOption)
                );
            });
            console.log("Items filtrados:", JSON.stringify(this.items));
            console.log("Items filtrados total:", this.items.length);
        },
        async forrmataData(dataAPI) {
            if (!this.selected || !Array.isArray(this.selected)) return;
            //this.formatos = formatos;
            const propriedades = this.selected.flatMap(modelo => modelo.properties || []);
            const propertyMap = {};
            propriedades.forEach(prop => {
                const propId = prop.propertie_id;
                const label = prop.propertie.name;
                const values = [];
                try {
                    const parsedValues = JSON.parse(prop.propertie.values || '[]');
                    parsedValues.forEach(v => values.push(v));
                } catch (e) {
                    console.warn(`Erro ao parsear valores da propriedade ${label}`, e);
                }
                propertyMap[propId] = { label, values };
            });

            this.originalItems = dataAPI.map(task => {
                const filtrosTraduziods = {};
                filtrosTraduziods["Mes"] = task.formato_data_mes ? task.formato_data_mes : null;
                filtrosTraduziods["Status"] = task.formato_status.toString();
                (task.all_values || []).forEach(v => {
                    const { propertie_id, value } = v;
                    const prop = propertyMap[propertie_id];
                    if (!prop) return;
                    const label = prop.label;
                    filtrosTraduziods[label] = value;
                });
                return {
                    ...task,
                    filters: filtrosTraduziods
                };
            });

            //this.items = [...this.originalItems];
            this.items = this.setItemsMes(this.mesOption);

            console.log('Dados formatados:', JSON.stringify(this.items));
        },
        setItemsMes(mes) {
            if (!mes || mes.length === 0) {
                return [];
            }
            const mesFiltra = mes;
            const data = JSON.parse(JSON.stringify(this.originalItems));
            const dataD = data
                .filter(task => {
                    const f = task.filters || {};
                    if (!f["Mes"] || !f["Mes"].includes(mesFiltra)) return false;
                    return true;
                })
            return dataD;
        },
        async setgraficosData() {
            this.graficosCarregando = true;
            const filtrados = this.items; //filtro de mes atual
            const mesAnteriorValue = this.mesOption != null && this.mesOption.length > 0 ? this.diminuiEFormata(this.mesOption[0]) : null;
            console.log('Mes Anterior Value:', mesAnteriorValue);
            const filtradosAnterior = this.setItemsMes(mesAnteriorValue);//filtro de mes anterior
            const versionamento = await this.setVersionamentoTotal(filtrados);
            const versionamentoTemplatizado = await this.setVersionamentoTemplatizadasTotal(filtrados);
            const volumePecas = await this.setVolumePecas(filtrados, filtradosAnterior);
            const demandasUnicas = await this.setDemandasUnicas(filtrados, filtradosAnterior);
            const templatizadas = await this.setTemplatizadas(filtrados, filtradosAnterior);
            this.graficosData = {
                versionamento,
                versionamentoTemplatizado,
                volumePecas,
                demandasUnicas,
                templatizadas
            }
            this.graficosCarregando = false;
        },
        async setVersionamentoTotal(filtrados) {
            const versionamentos = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
            };
            filtrados.forEach(e => {
                if (e.task_id != null) {
                    let index = e.formato_versionamento;
                    if (Object.prototype.hasOwnProperty.call(versionamentos, index)) {
                        if (index < 4) {
                            versionamentos[index] += 1;
                        } else {
                            versionamentos[4] += 1;
                        }

                    }
                }
            });
            const filteredVersionamentos = Object.entries(versionamentos)
                .filter(([_, value]) => value > 0)
                .reduce((obj, [key, value]) => {
                    obj[key] = value;
                    return obj;
                }, {});
            return {
                type: 'pie',
                series: Object.values(filteredVersionamentos),
                labels: Object.keys(filteredVersionamentos).map(key => `Versão ${key}`)
            };
        },
        async setVersionamentoTemplatizadasTotal(filtrados) {
            const versionamentos = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
            };
            filtrados.map(e => {
                if (e.formato_qtda_templatizada != 0 && e.formato_versionamento != 0) {
                    if (e.formato_versionamento < 4) {
                        versionamentos[e.formato_versionamento] = versionamentos[e.formato_versionamento] + e.formato_qtda_templatizada
                    } else {
                        versionamentos[4] = versionamentos[4] + e.formato_qtda_templatizada
                    }
                }
            });
            const filteredVersionamentos = Object.entries(versionamentos)
                .filter(([_, value]) => value > 0)
                .reduce((obj, [key, value]) => {
                    obj[key] = value;
                    return obj;
                }, {});

            return {
                type: 'pie',
                series: Object.values(filteredVersionamentos),
                labels: Object.keys(filteredVersionamentos).map(key => `Versão ${key}`)
            };
        },
        async setVolumePecas(filtrados, filtradosAnterior) {
            const total = filtrados
                .reduce((acc, task) => acc + Number(task.formato_qtda || 0), 0);
            let porcentagem = 0;
            let anterior = 0;
            console.log('anterior: ', filtradosAnterior != null, filtradosAnterior.length > 0)
            if (filtradosAnterior != null && filtradosAnterior.length > 0) {
                anterior = filtradosAnterior
                    .reduce((acc, task) => acc + Number(task.formato_qtda || 0), 0);
                porcentagem = (((total / anterior) * 100) - 100).toFixed(2);
            }
            return { total, anterior, porcentagem };
        },
        async setDemandasUnicas(filtrados, filtradosAnterior) {
            let total_array = [];
            let total_anterior_array = [];
            let total = 0;
            let anterior = 0;
            let porcentagem = 0;

            filtrados.forEach(e => {
                if (e.task_id != null && !total_array.includes(e.task_id)) {
                    total_array.push(e.task_id);
                }
            });

            total = total_array.length;

            if (filtradosAnterior != null && filtradosAnterior.length > 0) {
                filtradosAnterior.forEach(e => {
                    if (e.task_id != null && !total_anterior_array.includes(e.task_id)) {
                        total_anterior_array.push(e.task_id);
                    }
                });
                anterior = total_anterior_array.length;
                porcentagem = (((total / anterior) * 100) - 100).toFixed(2);
            }

            return { total, anterior, porcentagem };
        },
        async setTemplatizadas(filtrados, filtradosAnterior) {

            const total_templatizadas = filtrados
                .reduce((acc, task) => acc + Number(task.formato_qtda_templatizada || 0), 0);

            let total = 0;
            let anterior = 0;
            let porcentagem = 0;

            if (filtradosAnterior != null && filtradosAnterior.length > 0) {
                const total_templatizadas_anterior = filtradosAnterior
                    .reduce((acc, task) => acc + Number(task.formato_qtda_templatizada || 0), 0);

                total = total_templatizadas;
                anterior = total_templatizadas_anterior;

                porcentagem = (((total / anterior) * 100) - 100).toFixed(2);
                return { total, anterior, porcentagem };
            }


            return { total, anterior, porcentagem };

        },



    }
}
</script>
<style>
.my-fixed-box {
    float: left;
    width: calc(16.66% - 3rem);
    height: 100%;
    text-align: left;
    padding: 0px;
}
</style>